/*
 * Copyright (c) 2023-2024. Haodong JU
 */
import Vue from 'vue'
import App from './App.vue'
import router from './model/global/router'
import store from './model/global/store'
import './plugins/apexchart'

import i18n from './i18n'
import Print from 'vue-print-nb'
import { loadConfig, requireOfflineMode } from './model/global/GlobalSettings'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import relativeTime from 'dayjs/plugin/relativeTime'
import vuetify from './plugins/vuetify'
import 'shepherd.js/dist/css/shepherd.css'
import VueCompositionAPI from '@vue/composition-api'
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueMarkdownEditor from '@dawizz/vue-markdown-editor'
import '@dawizz/vue-markdown-editor/lib/theme/style/vuepress.css'
import '@dawizz/vue-markdown-editor/lib/style/base-editor.css'
import vuepressTheme from '@dawizz/vue-markdown-editor/lib/theme/vuepress.js'
import Prism from 'prismjs'
// highlight code
import 'prismjs/components/prism-json'

Vue.use(Print)
Vue.use(VueCompositionAPI)
VueMarkdownEditor.use(vuepressTheme, {
  Prism
})
Vue.component('MarkdownEditor', VueMarkdownEditor)
const duration = require('dayjs/plugin/duration')
const isoWeek = require('dayjs/plugin/isoWeek')
const utc = require('dayjs/plugin/utc')
dayjs.extend(isoWeek)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(weekday)
dayjs.extend(utc)
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

export function uuidv4 () {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g,
    c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
}

export let lastRoute = ''

export function resetLastRoute () {
  lastRoute = ''
}

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.name !== 'LoginPage' && (to.name !== 'cancel' && to.name !== 'success')) {
    if (!token && !requireOfflineMode()) {
      lastRoute = to.name
      next({ name: 'LoginPage' })
    } else {
      next()
    }
  } else {
    next()
  }
})

async function initial () {
  await loadConfig()

  new Vue({
    pinia,
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

initial()
